




























































import CommonMixin from '@/mixins/CommonMixin';
import CustomField from '@/components/CustomField.vue';
import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';

@Component({
  components: {
    CustomField
  }
})
export default class Poles extends Mixins(CommonMixin) {
  // Props
  @Prop(Object) public rec!: object;
  @Prop(Boolean) public isReadOnly!: boolean;

  public get routeControlLabels() {
    const labels: string[] = [];
    const rec: any = this.rec;
    for (let i = 0; i < rec.site.start_site_count; i++) {
      labels.push('Entry ' + (i + 1));
    }
    for (let i = 0; i < rec.site.end_site_count; i++) {
      labels.push('Exit ' + (i + 1));
    }
    return labels;
  }

  public getLabel(index) {
    return this.isSite()
      ? 'Paal ' + (index + 1)
      : this.routeControlLabels[index];
  }
}
